import React from 'react';
import {hydrateRoot} from 'react-dom/client';

const DynamicCalculator = React.lazy(() => import("@/views/salary-calculator/DynamicCalculator.jsx"));
const AppPromoAnimation = React.lazy(() => import("@/views/salary-calculator/AppPromoAnimation.jsx"));

if (document.getElementById('dynamic-calculator')) {
    const data_id = document.getElementById('dynamic-calculator').getAttribute('data-id');

    hydrateRoot(
        document.getElementById('dynamic-calculator'),
        <DynamicCalculator data_id={data_id}/>
    );
}

if (document.getElementById('app-promo-animation')) {
    hydrateRoot(
        document.getElementById('app-promo-animation'),
        <AppPromoAnimation/>
    );
}
